var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.283,
    height: 15.273,
    viewBox: "0 0 15.283 15.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy",
    "data-name": "Shape 1 copy",
    d: "M4399.292,979a3.371,3.371,0,0,0-4.77,0l-8.746,8.739a.425.425,0,0,0-.125.251l-.648,4.8a.436.436,0,0,0,.124.368.444.444,0,0,0,.31.13.371.371,0,0,0,.058,0l2.891-.391a.44.44,0,1,0-.117-.872l-2.32.312.454-3.346,3.523,3.521a.442.442,0,0,0,.31.13.432.432,0,0,0,.309-.13l8.746-8.739a3.365,3.365,0,0,0,0-4.768Zm-4.6,1.074,1.47,1.468-7.983,7.977-1.467-1.468Zm-4.451,11.5-1.436-1.435,7.98-7.977,1.436,1.435Zm8.593-8.605-3.513-3.512a2.495,2.495,0,0,1,3.513,3.512Z",
    transform: "translate(-4384.999 -978.014)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDefault);
export default __webpack_public_path__ + "static/media/pencil-default.983c8e3d.svg";
export { ForwardRef as ReactComponent };